var _path, _rect, _path2, _path3, _rect2, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXlsxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.8259 3.1748H12.7307C10.5216 3.1748 8.73071 4.96567 8.73071 7.17481V46.7938C8.73071 49.003 10.5216 50.7938 12.7307 50.7938H38.4752C38.7404 50.7938 38.9948 50.6885 39.1823 50.501L46.533 43.1502C46.7206 42.9627 46.8259 42.7083 46.8259 42.4431V7.1748C46.8259 4.96567 45.0351 3.1748 42.8259 3.1748Z",
    fill: "#EFEEEE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 14.2866,
    width: 31.746,
    height: 15.873,
    rx: 2,
    fill: "#EFEEEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9049 1H46.0001C47.657 1 49.0001 2.34315 49.0001 4L49.0001 39.2683L41.6494 46.619H15.9049C14.2481 46.619 12.9049 45.2759 12.9049 43.619V4C12.9049 2.34315 14.2481 1 15.9049 1Z",
    fill: "#EFEEEE",
    stroke: "#2E2E38",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.809 39.6819L42.063 46.4279V39.6819H48.809Z",
    fill: "#D8D8D8",
    stroke: "#2E2E38"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.1748,
    y: 12.1118,
    width: 32.9206,
    height: 13.873,
    rx: 1,
    fill: "#19913D",
    stroke: "#2E2E38",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4957 23.0146H11.8481L10.2671 20.4432L8.68617 23.0146H7.14331L9.40045 19.5099L7.28617 16.2146H8.87664L10.3433 18.6622L11.7814 16.2146H13.3338L11.2005 19.5861L13.4957 23.0146Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5432 23.0146V16.2146H16.9813V21.8241H19.7432V23.0146H15.5432Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1283 21.1289C26.1283 21.7321 25.9092 22.2146 25.4711 22.5765C25.0394 22.9321 24.4235 23.1099 23.6235 23.1099C22.9061 23.1099 22.2648 22.9734 21.6997 22.7003V21.3575C22.0235 21.4972 22.3569 21.6273 22.6997 21.748C23.0489 21.8622 23.3949 21.9194 23.7378 21.9194C24.0934 21.9194 24.3442 21.8527 24.4902 21.7194C24.6426 21.5797 24.7188 21.4051 24.7188 21.1956C24.7188 21.0241 24.6584 20.8781 24.5378 20.7575C24.4235 20.6368 24.268 20.5257 24.0711 20.4241C23.8743 20.3162 23.6489 20.2019 23.3949 20.0813C23.2362 20.0051 23.0648 19.9162 22.8807 19.8146C22.6965 19.7067 22.5188 19.5765 22.3473 19.4241C22.1822 19.2654 22.0457 19.0749 21.9378 18.8527C21.8299 18.6305 21.7759 18.3638 21.7759 18.0527C21.7759 17.4432 21.9822 16.9702 22.3949 16.6337C22.8076 16.2908 23.3696 16.1194 24.0807 16.1194C24.4362 16.1194 24.7727 16.1607 25.0902 16.2432C25.4076 16.3257 25.7442 16.4432 26.0997 16.5956L25.633 17.7194C25.3219 17.5924 25.0426 17.494 24.7949 17.4241C24.5473 17.3543 24.2934 17.3194 24.033 17.3194C23.76 17.3194 23.5505 17.3829 23.4045 17.5099C23.2584 17.6368 23.1854 17.8019 23.1854 18.0051C23.1854 18.2464 23.2934 18.4368 23.5092 18.5765C23.7251 18.7162 24.0457 18.8876 24.4711 19.0908C24.8203 19.2559 25.1156 19.4273 25.3569 19.6051C25.6045 19.7829 25.7949 19.9924 25.9283 20.2337C26.0616 20.4749 26.1283 20.7734 26.1283 21.1289Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.05 23.0146H32.4024L30.8214 20.4432L29.2405 23.0146H27.6976L29.9548 19.5099L27.8405 16.2146H29.431L30.8976 18.6622L32.3357 16.2146H33.8881L31.7548 19.5861L34.05 23.0146Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsxIcon);
export default __webpack_public_path__ + "static/media/xlsx-icon.5a9c54763dce3bd21bdf5a0cdea10965.svg";
export { ForwardRef as ReactComponent };